import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取列表
export const getList = data => {
  return axios.request({
    url: "/shipments/multiPackageList",
    data,
    method: "post"
  });
};

export const getChildPackage = params => {
  return axios.request({
    url: "/shipments/getChildPackage",
    params,
    method: "get"
  });
};

export const saveValues = data => {
  return axios.request({
    url: "/shipments/multi_vote/saveValues/"+data.client_refer_code,
    data,
    method: "post"
  });
};

export const getValuesLogs = id => {
  return axios.request({
    url: "/shipments/multi_vote/getValuesLogs/"+id,
    method: "get"
  });
};


export const addFee = data => {
  return axios.request({
    url: "/shipments/multi_vote/addFee",
    data,
    method: "post"
  });
};

export const delFee = data => {
  return axios.request({
    url: "/shipments/multi_vote/delFee/"+data.client_refer_code,
    data,
    method: "delete"
  });
};

export const updateFee = data => {
  return axios.request({
    url: "/shipments/multi_vote/updateFee/"+data.client_refer_code,
    data,
    method: "post"
  });
};

export const getFee = id => {
  return axios.request({
    url: "/shipments/multi_vote/getOtherFee/"+id,
    method: "get"
  });
};

export const saveFee = data => {
  return axios.request({
    url: "/shipments/multi_vote/saveFee/"+data.client_refer_code,
    method: "post",
		data
  });
};

export const uploadFiles = (data) => {
  return axios.request({
    url: `/shipments/multi_vote/batchUpload`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken(),
    },
    data,
  });
};


export const boxList = id => {
  return axios.request({
    url: "/shipments/multi_vote/boxList/"+id,
    method: "get"
  });
};

export const allowToAgent = data => {
  return axios.request({
    url: "/shipments/multi_vote/allowToAgent/"+data.client_refer_code,
    method: "post",
		data
  });
};